import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { RoutePath } from 'routes/route-path.constant';
import { BaseContext } from 'context/base.context';

import { useLocalStorage } from 'hooks/use-local-storage.hook';
import { useSaveAnswers } from 'hooks/use-save-answers.hook';

import { LocalStorageKeys } from 'constants/local-storage';
import { TypographyVariants } from 'constants/typography-variants';

import { Typography } from 'components/typography';
import { ChoiceButton, ChoiceType } from 'components/choice-button';

export const LoseWeight = () => {
    const { t } = useTranslation();
    const saveAnswers = useSaveAnswers();

    const { pageConfiguration } = useContext(BaseContext);

    const pageKey = LocalStorageKeys[RoutePath.LoseWeight];

    const { pageValue: loseWeight, setPageValue }: any = useLocalStorage({
        key: pageKey,
        defaultValue: '',
    });

    const handleClick = (answer: ChoiceType) => {
        setPageValue(answer.key);
        saveAnswers({
            key: pageKey,
            itemQuestion: { question: t('lose-weight-title'), value: t(answer.value) },
        });

        pageConfiguration.handleOnPageComplete(answer.value);
    };

    const answers: ChoiceType[] = [
        {
            key: 'whole-life',
            value: t('lose-weight-option-whole-life'),
        },
        {
            key: 'less-than-six-months',
            value: t('lose-weight-option-less-than-six-months'),
        },
        {
            key: 'six-twelve-months',
            value: t('lose-weight-option-six-twelve-months'),
        },
        {
            key: 'several-years',
            value: t('lose-weight-option-several-years'),
        },
        {
            key: 'never',
            value: t('lose-weight-option-never'),
        }
    ];

    return (
        <>
            <Typography variant={TypographyVariants.h1}>
                {t('lose-weight-title')}
            </Typography>

            {answers.map((v: ChoiceType) => (
                <ChoiceButton
                    key={v.key}
                    center={true}
                    selected={v.key === loseWeight}
                    typographyText={v.value}
                    onClick={() => handleClick(v)}
                />
            ))}
        </>
    );
};
